import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { DashboardPostbackIndexMapping } from '../../../../../../shared/types/skadNetwork.types';

const SetCurrentConversionValueMapping = new ReduxAsyncAction<
  'SET_CURRENT_CONVERSION_VALUE_MAPPING',
  DashboardPostbackIndexMapping,
  DashboardPostbackIndexMapping
>('SET_CURRENT_CONVERSION_VALUE_MAPPING');

SetCurrentConversionValueMapping.registerRequest(async (mapping: DashboardPostbackIndexMapping) => {
  return mapping;
});

export const SET_CURRENT_CONVERSION_VALUE_MAPPING = SetCurrentConversionValueMapping.actionNamespaceConstants;

export const setCurrentConversionValueMapping = SetCurrentConversionValueMapping.request;

export type SetCurrentConversionValueMappingResponseAction = Action<typeof SET_CURRENT_CONVERSION_VALUE_MAPPING.response> & {
  data: DashboardPostbackIndexMapping;
};
